<template>
  <div class="width-100 min-height" style="padding: 5% 5% 0">
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" class="width-100">
      <div class="width-100 flex-row align-items-center justify-content-spaceBetween border-b" v-for="(item, key) in list" :key="key">
        <div class="flex-row align-items-center justify-content-start">
          <div
            style="width: 2rem; height: 2rem"
            :class="[item.type == 1 ? 'sign-in' : item.type == 2 ? 'extend' : item.type == 3 ? 'review' : item.type == 4 ? 'give-like' : 'other']"
          />
          <div class="flex-column align-items-star justify-content-spaceBetween margin-ls">
            <div class="fs-mid-sml fm-sh-regular">
              <!-- {{
                item.type == 1 ? '完成签到' : item.type == 2 ? '推广次数+1' : item.type == 3 ? '完成评论' : item.type == 4 ? '完成点赞' : '完成阅读'
              }} -->
              {{ item.type_name }}
            </div>
            <div class="fs-sml fm-sh-regular grey-999">{{ item.contribute_date }}</div>
          </div>
        </div>
        <div class="fs-big fm-sh-bold">+{{ item.score }}</div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { getMemberContributeLists } from '../api/zhishu';
export default {
  data() {
    return {
      loading: false,
      finished: false,
      list: [],
      searchObj: {
        pageNum: 0,
        pageSize: 10
      }
    };
  },
  mounted() {},
  methods: {
    getMemberContributeLists() {
      let date = new Date();
      getMemberContributeLists({
        month: this.$route.query.month ? this.$dayjs(this.$route.query.month).format('YYYY-MM-DD') : this.$dayjs(date).format('YYYY-MM-DD'),
        page: this.searchObj.pageNum
      }).then((res) => {
        this.list = this.list.concat(res.data);
        if (res.data.length == 0) {
          this.finished = true;
        }
        this.loading = false;
      });
    },
    onLoad() {
      this.searchObj.pageNum += 1;
      this.getMemberContributeLists();
    }
  }
};
</script>

<style scoped>
.other {
  background-image: url('../assets/image/luckyDrawDetails/extend.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.extend {
  background-image: url('../assets/image/luckyDrawDetails/extend.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.sign-in {
  background-image: url('../assets/image/luckyDrawDetails/sign-in.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.review {
  background-image: url('../assets/image/luckyDrawDetails/review.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.give-like {
  background-image: url('../assets/image/luckyDrawDetails/give-like.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>
